import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TabsForm from "@/components/building/TabsForm.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'NewBuildingView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TabsForm, { class: "w-5/6 p-[2%]" }))
}
}

})